import { ValidatorFn, Validators } from '@angular/forms';
import { TransferProduct } from '../../core/api/products/entities/product-action.entity';
import { ProductActiveStockItem } from '../../core/api/products/entities/product-active-stock-item.entity';
import { QuantityUnit } from '../../core/api/quantity-units/entities/quantity-unit.entity';
import { positive } from '../form-control-options.constants';
import { QuickActionTransferFormControls } from '../form-controls/quick-action.form-controls';
import { QuickActionForm } from './quick-action.form';

export class QuickActionTransferForm extends QuickActionForm<QuickActionTransferFormControls> {
  formGroup = this.createFormGroup(QuickActionTransferFormControls);

  public get amountHint(): string | undefined {
    return undefined;
  }

  public get productAction(): TransferProduct {
    return {
      amount: this.amount,
      productId: this.product!.id,
      fromLocationId: this.controls.stockItem.value!.locationId!,
      stockItemId: this.controls.stockItem.value!.id,
      toLocationId: this.controls.toLocation.value!.id,
    };
  }

  public get quantityUnit(): QuantityUnit | undefined {
    return this.product?.quantityUnitStock;
  }

  public setAmountToMax(): void {
    if (this.product && this.controls.stockItem.value) {
      this.controls.amount.setValue(this.controls.stockItem.value.amount);
    }
  }

  public override canSelectStockItem(stockItem: ProductActiveStockItem): boolean {
    return stockItem.amount > 0;
  }

  protected setChangeListeners(): void {
    this.controls.stockItem.valueChanges.subscribe(stockEntry => {
      if (stockEntry) {
        this.controls.amount.setValidators([
          Validators.required,
          Validators.min(0.000001),
          Validators.max(stockEntry.amount),
        ]);
        this.controls.amount.setValue(stockEntry.amount);
        this.controls.amount.updateValueAndValidity();

        this.controls.toLocation.setValue(this.options.locations.find(l => l.id === stockEntry.locationId)!);
      }
    });
  }

  protected setInitialValues(): void {
    this.controls.amount.setValidators([
      ...(positive.validators as ValidatorFn[]),
      Validators.max(this.product?.activeStockAmount || 0),
    ]);

    if (this.product) {
      if (this.product?.activeStockItems.length === 0) {
        this.disableForm();
      } else {
        const stockItem = this.product?.activeStockItems[0];
        this.controls.stockItem.setValue(stockItem);
        this.controls.fromLocation.setValue(this.options.locations.find(l => l.id === stockItem.locationId)!);
        this.controls.toLocation.setValue(this.options.locations.find(l => l.id === stockItem.locationId)!);
        this.enableForm();
      }
    }
  }

  private disableForm(): void {
    this.controls.amount.disable();
    this.controls.stockItem.disable();
    this.controls.toLocation.disable();
    this.formGroup.markAllAsTouched();
  }

  private enableForm(): void {
    this.controls.amount.enable();
    this.controls.stockItem.enable();
    this.controls.toLocation.enable();
  }
}
